import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
} from '@angular/core';

import {Constants} from '../../../shared/config/constants.config';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {MasterNote, MasterService} from '../../../shared/services/master.service';
import {NotificationsService} from '../../../shared/services/notification.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UsersService} from '../../../shared/services/users.service';
import {UserProfileViewModel} from '../../../shared/viewModels/userProfile.viewModel';
import {AuthService} from '../../../shared/services/auth.service';
import {ProfilesCreateModalComponent} from '../profiles-create/profiles-create.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from '../../../shared/events/bsModal.events';
import {ViewNoteComponent} from './view-note/view-note.component';

@Component({
    selector: 'app-notes',
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotesComponent {
    activeTab = 'personal';
    id: number;
    profile: UserProfileViewModel;
    notes: MasterNote[];

    bsModalRef: BsModalRef;

    constructor(
        public readonly constants: Constants,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly masterService: MasterService,
        private readonly usersService: UsersService,
        private readonly authService: AuthService,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly notificationService: NotificationsService,
        private readonly route: ActivatedRoute,
        readonly router: Router,
        public readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter
    ) {
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnInit() {
        this.route.params.subscribe(params => {
            // tslint:disable-next-line:radix
            this.id = parseInt(params['id']);

            const activeTab = this.route.snapshot.paramMap.get('section');

            if (activeTab) {
                this.activeTab = activeTab;
                this.changeDetectorRef.detectChanges();
            }

            this.masterService.getUserProfile(this.id).subscribe(profile => {
                this.profile = profile;
                this.changeDetectorRef.markForCheck();
            });

            this.init();
        });
    }

    init() {
        this.masterService.getNotes(this.id).subscribe(notes => {
            this.notes = notes;
            this.changeDetectorRef.markForCheck();
        });
    }

    openUserMeals(profile: UserProfileViewModel) {
        this.masterService.masterLogin(profile.id).subscribe(token => {
            this.authService.setStorageItem('original_logged_token', this.authService.getJWT());
            this.authService.setStorageItem('master_sub_profile_logged_token', token.token);

            this.router.navigate(['/master/meals', profile.id]);
        });
    }

    openMessages(profile: UserProfileViewModel) {
        this.router.navigate(['/master/messages', profile.id]);
    }

    delete(note: MasterNote) {
        this.masterService.deleteNote(this.profile.id, note.id).subscribe(() => {
            this.init();
        });
    }

    shortHtml(text: string) {
        let plain = this.removeHTML(text);

        if (plain.length > 40) {
            plain = plain.substring(0, 40) + ' ...';
        }

        return plain;
    }

    removeHTML(str) {
        const tmp = document.createElement('DIV');
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText || '';
    }

    showFullNote(note: MasterNote) {
        this.bsModalRef = this.bsModalService.show(ViewNoteComponent, {
            backdrop: true
        });

        this.bsModalRef.content.title = note.title;
        this.bsModalRef.content.text = note.text;
        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);

    }
}
